import { Badge, Image } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useLogin } from "../../../context/LoginContext";
import { useShoppingCart } from "../../../context/ShoppingCartContext";
import Cart from "./images/Cart";
import Order from "./images/Order";
import Personal from "./images/Personal";
import Shop from "./images/Shop";
import userIcon from "./images/userIcon.png";
import styles from "./style.2esim.module.scss";

const TabBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [currentMod, setCurrentMod] = useState<any>();
  const { pathname, search } = useLocation();
  const { cartCount } = useShoppingCart();
  const { isLogin } = useLogin();

  const methods = [
    {
      id: "shop",
      name: t("normal.shop"),
      code: "shop",
      icon: Shop,
      path: "/",
    },
    {
      id: "order",
      name: t("footer.myOrder"),
      code: "order",
      icon: Order,
      path: "/usercenter?tab=orderinquiry",
      needLoggedIn: true,
    },
    {
      id: "cart",
      name: t("normal.cart"),
      icon: Cart,
      code: "cart",
      path: "/cart",
    },
    {
      id: "login",
      name: t("normal.siginin"),
      icon: Personal,
      code: "login",
      path: "/signin",
      needLoggedIn: true,
      hideIfLoggedIn: isLogin,
    },
    {
      id: "personal",
      name: t("footer.personal"),
      icon: Personal,
      code: "me",
      path: "/usercenter?tab=userinfo",
      hideIfLoggedIn: !isLogin,
    },
  ];

  const updateCurrentMod = () => {
    if (pathname === "/usercenter") {
      const target = methods.find((m) => m.path === pathname + search);
      setCurrentMod(target?.id);
    }
    // else {
    //   const target = methods.find((m) => m.path === pathname);
    //   setCurrentMod(target?.id);
    // }
  };

  const handleTabClick = (m: any) => {
    if (isLogin) {
      setCurrentMod(m.id);
      navigate(m.path);
    } else {
      setCurrentMod(m.id);
      if (m.needLoggedIn) {
        if (pathname !== "/signin") {
          navigate("/signin");
        }
      } else {
        navigate(m.path);
      }
    }
  };

  useEffect(() => {
    updateCurrentMod();
  }, [pathname, search]);

  return (
    <div className={styles.container}>
      <div className={styles.tabbar}>
        <ul className={styles.tabbarItems}>
          {methods
            .filter((h) => !h.hideIfLoggedIn)
            .map((m, index) => (
              <li
                className={`${styles.item} ${
                  currentMod === m.id ? styles.active : ""
                }`}
                key={"tabbar" + index}
                onClick={() => handleTabClick(m)}
              >
                <div className={styles.content}>
                  {m.id === "cart" ? (
                    <span className={styles.icon}>
                      <Badge count={cartCount}>
                        <m.icon
                          color={
                            currentMod === m.id
                              ? "var(--primary500)"
                              : "var(--primary700)"
                          }
                        ></m.icon>
                      </Badge>
                    </span>
                  ) : (
                    <span className={styles.icon}>
                      {m.id === "personal" ? (
                        <Image
                          src={userIcon}
                          className={styles.userLogo}
                          preview={false}
                        />
                      ) : (
                        <m.icon
                          color={
                            currentMod === m.id
                              ? "var(--primary500)"
                              : "var(--primary700)"
                          }
                        ></m.icon>
                      )}
                    </span>
                  )}

                  <span className={styles.text}>{m.name.toUpperCase()}</span>
                </div>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default TabBar;
